// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a3ceef6","239":"c0b07d82","732":"ea90fd40"}[chunkId] + ".chunk.js";
};